import React from "react";
import "./serviceIcon.scss"
import { useNavigate } from "react-router-dom";
const ServiceIcon=({icon:Icon,title,content, path}) => {

    const navigate = useNavigate();
    const handleNavigate = () => {
        if(path)
            
        navigate(path)
    }
    return(
        <div className="service-icon-container">
            <Icon className="service-icon" style={{cursor: 'pointer'}} onClick={() => handleNavigate()}/>
            <div className="service-title" style={{cursor: 'pointer'}} onClick={() => handleNavigate()}>{title}</div>
            <div className="service-content">{content}</div>
        </div>
    )
}

export default ServiceIcon;